{
  "holdingAreaListItem": {
    "imageAlt": "N/D",
    "tenantTypes": {
      "transient": "Passager",
      "base": "Base",
      "yellowCard": "Base + Carte Jaune"
    },
    "unknownModel": "Modèle inconnu",
    "buttons": {
      "assign": "Attribuer",
      "edit": "Édit.",
      "remove": "Supprimer"
    },
    "confirmDialog": {
      "title": "Retirer l'aéronef de la zone d'attente ?",
      "text": "Voulez-vous vraiment retirer {{identifier}} de la zone d'attente ?",
      "okButton": "Supprimer",
      "cancelButton": "Annuler"
    }
  },
  "assignAircraftDialog": {
    "title": "Attribuer un aéronef à un emplacement",
    "sections": {
      "hangars": "Hangars",
      "ramps": "Tarmacs"
    },
    "messages": {
      "mayBeTooSmall": "Peut être trop petit",
      "noLocations": "Aucun hangar ou tarmac disponible"
    },
    "buttons": {
      "cancel": "Annuler",
      "assign": "Attribuer",
      "assigning": "Attribution..."
    }
  },
  "holdingAreaPresenter": {
    "title": "Zone d'attente"
  },
  "holdingAreaList": {
    "title": "Zone d'attente ({{count}})",
    "emptyState": "Aucun aéronef en zone d'attente"
  },
  "printLayout": {
    "hangarCount": "{{count}} Hangar",
    "sqft": " pi²",
    "aircraft": "Aéronef",
    "utilization": "Utilisation"
  },
  "multiHangarInfoCard": {
    "title": "Résumé multi-hangars",
    "labels": {
      "aircraft": "Aéronef",
      "utilization": "Utilisation",
      "totalSqft": "Superf. totale",
      "totalUtilized": "Total utilisé",
      "estValue": "Valeur est.",
      "total": "Total",
      "transients": "Transients",
      "estTowTime": "Tps remor."
    },
    "tooltips": {
      "numberOfHangars": "Nombre de hangars sélectionnés",
      "aircraftCount": "Aéronefs dans les hangars / Total des aéronefs dans les hangars sélectionnés",
      "utilization": "Utilisation combinée de tous les hangars sélectionnés",
      "totalSqft": "Surface totale au sol des hangars sélectionnés",
      "totalUtilized": "Surface au sol totale occupée par les aéronefs",
      "estValue": "Valeur combinée estimée de tous les hangars par jour",
      "transientValue": "Revenue from overnight transient aircraft.",
      "estTowTime": "Temps de remorquage total estimé pour tous les hangars"
    }
  }
}
